import axiosInstance from "../axiosInstance";

export const studentsApi = {
    post: (path, params, headers, cancelToken) =>
        axiosInstance
            .post(`/Students${path}`, params, {
                cancelToken: cancelToken?.token,
                headers,
            })
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
                // if (res?.data?.error || res?.data?.status === 'error') throw res.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            }),
    get: (path, params, headers, cancelToken) =>
        axiosInstance
            .get(
                `/Students${path}`,
                { params },
                {
                    cancelToken: cancelToken?.token,
                    headers,
                }
            )
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            }),
};

export const getNewApplicationTypes = async () =>
    studentsApi.get("/GetNewApplicationTypes");

export const getInstitutes = async (params) =>
    studentsApi.post(
        "/GetInstitutesByTypeSelection",
        JSON.stringify(params),
        { "Content-Type": "application/json" }
    );

export const getAdditionalInstitutes = async (params) =>
    studentsApi.post("/GetAdditionalInstitutes", JSON.stringify(params), {
        "Content-Type": "application/json",
    });

export const getStudents = async () =>
    studentsApi.get("/GetStudents");

export const createApplication = async (params) =>
    studentsApi.post("/Create", JSON.stringify(params), {
        "Content-Type": "application/json",
    });

export const getApplication = async (id) =>
    studentsApi.get(`/GetApplication/${id}`);

export const getAmkaRegistryInfo = async (params) =>
    studentsApi.get("/GetAmkaRegistryInfo", params);

export const updateApplication = async (params) => {
    return studentsApi.post("/Update", JSON.stringify(params), {
        "Content-Type": "application/json",
    });
};

export const getAmendmentStatus = async (id) =>
    studentsApi.get(`/GetAmendmentStatus/${id}`);

export const amendApplication = async (params) => {
    return studentsApi.post("/AmendApplication", JSON.stringify(params), {
        "Content-Type": "application/json",
    });
};

export const getChildAmkaDataIfGuardian = async (id, amka) => {
    return studentsApi.get(`/getChildAmkaDataIfGuardian/${id}`, { amka });
};

export const confirmCopyFromFamilyApp = async (params) => {
    return studentsApi.post("/ConfirmCopyFromFamilyApp", JSON.stringify(params), {
        "Content-Type": "application/json",
    });
};

